import type { Node as ProseMirrorNode } from '@tiptap/pm/model';

import { TiptapNodeType } from '../../tiptapTypes';
import { getChildTaskList } from './taskListItemNodeUtils';

/**
 * Checks whether the task item at a position can be dragged out of its list.
 *
 * Moving the last task out leaves an empty task in its place. We allow that when the list shows
 * a title (an empty title counts). With no title, the list left behind would be empty. The only
 * task of an untitled list can't be dragged out. Its sub-tasks can.
 */
export const canDragTaskItemOut = (doc: ProseMirrorNode, position: number): boolean => {
    if (doc.firstChild?.type.name === TiptapNodeType.taskListTitle) return true;

    const taskList = getChildTaskList(doc);

    if (!taskList || taskList.node.childCount !== 1) return true;

    // `offset` is the list's position in the doc; +1 steps inside it to the only task.
    return position !== taskList.offset + 1;
};
